module.exports = __webpack_public_path__ + "img/sample-high.02673f52.jpg";